import { configureStore } from "@reduxjs/toolkit";
import generalReducer from "./slices/generalSlice";
import accountDetailReducer from "./slices/accountDetailSlice";
import activeComponentsReducer from "./slices/activeComponentsSlice";
// import eBulletinReducer from "./slices/ebulletinSlice";

const store = configureStore({
  reducer: {
    generalSlice: generalReducer,
    accountDetailSlice: accountDetailReducer,
    activeComponentsSlice: activeComponentsReducer,
    // ebulletinSlice: eBulletinReducer,
  },
});

export default store;
